<template>
  <tr v-if="!esEditable">
    <td class="text-right">
      <router-link
        :to="{
          name: 'ordenes.registros',
          params: { idOrden: item.idOrden },
        }"
        class="btn btn-xs btn-icon btn-light-primary"
      >
        <span class="fa fa-fw fa-eye"></span>
      </router-link>
      <template v-if="!estaLiquidado">
        <button class="btn btn-xs btn-icon btn-light-warning ml-1" @click="onEdit">
          <i class="fa fa-pen"></i>
        </button>
        <button class="btn btn-xs btn-icon btn-light-danger ml-1" @click="onDelete" :disabled="loading.save">
          <i class="far fa-trash-alt"></i>
        </button>
      </template>
      <button class="btn btn-xs btn-icon btn-light-success ml-1" @click="$root.$emit('show:ordenDeServicio:liquidar', item)">
        <i class="fa fa-dollar-sign"></i>
      </button>
    </td>
    <td class="text-center">
      <template>{{ item.codigo }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.fecha | date }}</template>
    </td>
    <td>
      <template>{{ item.servicio }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.horaSalida | date("HH:mm:ss", "HH:mm") }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.idioma }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.registros }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.nroAdultos }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.nroNinos }}</template>
    </td>
    <td>
      <template>{{ item.vehiculo }}</template>
    </td>
    <td>
      <template>{{ item.conductor || item.otroConductor }}</template>
    </td>
    <td class="text-center">
      <template>{{ contacto }}</template>
    </td>
    <td>
      <template>{{ item.guia }}</template>
    </td>
    <td>
      <template>{{ item.asistente }}</template>
    </td>
    <td>
      <template>{{ item.transfer }}</template>
    </td>
    <td>
      <template>{{ item.observacion }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.awanacancha }}</template>
    </td>
    <td class="text-center text-truncate" :title="item.usuarioCreador">
      <template>{{ item.usuarioCreador }}</template>
    </td>
    <td class="text-center text-truncate" :title="item.usuarioModificador">
      <template>{{ item.usuarioModificador }}</template>
    </td>
  </tr>
  <ValidationObserver v-else tag="tr" ref="form" :vid="String(item.idOrden)">
    <td class="text-right">
      <button class="btn btn-xs btn-icon btn-light-primary" @click="onSave" :disabled="loading.save">
        <i class="fa fa-check"></i>
      </button>
      <button class="btn btn-xs btn-icon btn-secondary ml-1" @click="onRemove" :disabled="loading.save">
        <i class="fa fa-times"></i>
      </button>
    </td>
    <td></td>
    <td>
      <InputDatepicker
        v-model="item.tempFecha"
        :errorMode="'tooltip'"
        :vid="`fecha_${item.idOrden}`"
        name="Fecha"
        rules="required"
        :editable="false"
        :inputClass="'form-control form-control-table'"
      ></InputDatepicker>
    </td>
    <td>
      <InputSelect
        v-model="item.tempServicio"
        :errorMode="'tooltip'"
        :vid="`servicio_${item.idOrden}`"
        name="Servicio"
        rules="required"
        :options="servicios"
        label="nombre"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td>
      <!-- <InputText
        v-model="item.tempHoraSalida"
        :errorMode="'tooltip'"
        :vid="`horaSalida_${item.idOrden}`"
        name="Salida"
        rules="time2"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText> -->
      <InputTime
        v-model="item.tempHoraSalida"
        :errorMode="'tooltip'"
        :vid="`horaSalida_${item.idOrden}`"
        name="Salida"
        rules="time2"
        :inputClass="'form-control form-control-table text-center'"
      ></InputTime>
    </td>
    <td colspan="4"></td>
    <td>
      <InputSelect
        v-model="item.tempVehiculo"
        :errorMode="'tooltip'"
        :vid="`vehiculo_${item.idOrden}`"
        name="Vehículo"
        :options="vehiculos"
        label="vehiculo"
        rules="required"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td>
      <template v-if="item.tempVehiculo">
        <InputSelect
          v-if="esVehiculoAmericana"
          v-model="item.tempConductor"
          :errorMode="'tooltip'"
          :vid="`conductor_${item.idOrden}`"
          name="Conductor"
          :options="conductores"
          label="nombreCompleto"
          input-class="form-control-table"
        ></InputSelect>
        <InputText
          v-else
          v-model="item.tempOtroConductor"
          :errorMode="'tooltip'"
          :vid="`otroConductor_${item.idOrden}`"
          name="Conductor"
          :inputClass="'form-control form-control-table'"
        ></InputText>
      </template>
    </td>
    <td>
      <InputText
        v-model="item.tempContacto"
        :errorMode="'tooltip'"
        :vid="`contacto_${item.idOrden}`"
        name="Contacto"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td>
      <InputSelect
        v-model="item.tempGuia"
        :errorMode="'tooltip'"
        :vid="`guia_${item.idOrden}`"
        name="Guía"
        :options="guias"
        label="nombre"
        rules="required"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td>
      <InputSelect
        v-model="item.tempAsistente"
        :errorMode="'tooltip'"
        :vid="`asistente_${item.idOrden}`"
        name="Asistente"
        :options="asistentes"
        label="nombre"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td>
      <InputText v-model="item.tempTransfer" :errorMode="'tooltip'" :vid="`transfer_${item.idOrden}`" name="Transfer" :inputClass="'form-control form-control-table'"></InputText>
    </td>
    <td>
      <InputText
        v-model="item.tempObservacion"
        :errorMode="'tooltip'"
        :vid="`observacion_${item.idOrden}`"
        name="Observación"
        :inputClass="'form-control form-control-table'"
      ></InputText>
    </td>
    <td class="text-center">
      <template v-if="mostrarCampoAwanacancha">
        <InputCheckbox v-model="item.tempAwanacancha" :errorMode="'tooltip'" :vid="`awanacancha_${item.idOrden}`" :noLabel="true" class="d-inline-block"></InputCheckbox>
      </template>
    </td>
    <td colspan="2"></td>
  </ValidationObserver>
</template>

<script>
import InputTime from '../../shared/components/InputTime.vue'
import InputCheckbox from "../../shared/components/InputCheckbox.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputText from "../../shared/components/InputText.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import { mapState } from "vuex";
import { parseTime } from "../../shared/helpers/time";

// campos conductor y contacto dependen de -> vehiculo

export default {
  components: { InputSelect, InputText, InputDatepicker, InputCheckbox, InputTime },
  props: {
    item: Object,
  },
  data() {
    return {
      loading: {
        save: false,
      },
      containers: {
        unwatchVehiculo: null,
        unwatchConductor: null,
      },
    };
  },
  computed: {
    estaLiquidado() {
      return this.item.idLiquidacion ? true : false;
    },
    esEditable() {
      return this.item.isNew || this.item.isEdit;
    },
    contacto() {
      let contacto = String(this.item.contactoConductor || "");
      contacto = contacto.split(" ");
      return contacto.join("");
    },
    mostrarCampoAwanacancha() {
      return this.item.tempServicio && this.item.tempServicio.idServicio == 2;
    },
    esVehiculoAmericana() {
      return this.item.tempVehiculo && this.item.tempVehiculo.propiedad == 1;
    },
    ...mapState("ordenesDeServicio", ["servicios", "vehiculos", "guias", "conductores", "asistentes"]),
  },
  watch: {
    esEditable(val) {
      const vm = this;
      console.log("esEditable", val);
      if (val) {
        vm.containers.unwatchVehiculo = vm.$watch("item.tempVehiculo", function(vehiculo, oldVehiculo) {
          if (vehiculo && vehiculo.idConductor) {
            const conductor = vm.conductores.find((conductor) => conductor.idPersona == vehiculo.idConductor);
            if (conductor) {
              vm.item.tempConductor = conductor;
            } else {
              vm.item.tempConductor = null;
            }
          } else {
            vm.item.tempConductor = null;
          }
        });

        vm.containers.unwatchConductor = vm.$watch("item.tempConductor", function(conductor, oldConductor) {
          if (conductor && conductor.telefono1) {
            vm.item.tempContacto = conductor.telefono1;
          } else {
            vm.item.tempContacto = "";
          }
        });
      } else {
        vm.containers.unwatchVehiculo();
        vm.containers.unwatchConductor();
      }
    },
  },

  methods: {
    async onSave() {
      const vm = this;
      const validated = await this.$refs.form.validate();

      if (!validated) return;

      vm.loading.save = true;

      const fd = {
        fecha: vm.item.tempFecha,
        idServicio: vm.item.tempServicio.idServicio,
        horaSalida: vm.item.tempHoraSalida ? parseTime(vm.item.tempHoraSalida) : null,
        idVehiculo: vm.item.tempVehiculo.idVehiculo,
        idConductor: vm.item.tempConductor?.idPersona || null,
        otroConductor: vm.esVehiculoAmericana ? null : vm.item.tempOtroConductor,
        contacto: vm.item.tempContacto || null,
        idGuia: vm.item.tempGuia.idPersona,
        idAsistente: vm.item.tempAsistente?.idPersona || null,
        transfer: vm.item.tempTransfer,
        observacion: vm.item.tempObservacion,
        awanacancha: vm.item.tempAwanacancha ? 1 : 0,
      };

      const endpoint = vm.item.isEdit ? vm.axios.put(`/ordenes/${vm.item.idOrden}`, fd) : vm.axios.post("/ordenes", fd);

      endpoint
        .then((response) => {
          vm.$toast.fire("", response.data.message, "success");
          vm.$store.dispatch("ordenesDeServicio/saveItem", {
            id: vm.item.idOrden,
            newId: response.data.content.idOrden,
            newCodigo: response.data.content.codigo,
          });
          vm.$emit("store");
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onEdit() {
      this.$store.dispatch("ordenesDeServicio/editItem", this.item.idOrden);
    },
    onCancel() {
      this.item.isEdit = false;
    },
    onRemove() {
      if (this.item.isEdit) return this.onCancel();

      this.$store.dispatch("ordenesDeServicio/removeItem", this.item.idOrden);
    },
    async onDelete() {
      const vm = this;
      const result = await vm.$confirm.fire("", "¿Estás seguro de eliminar este registro?");
      if (!result.value) return;

      vm.loading.save = true;

      vm.axios
        .delete(`/ordenes/${vm.item.idOrden}`)
        .then((response) => {
          vm.$toast.fire("", response.data.message, "success");
          this.$store.dispatch("ordenesDeServicio/removeItem", vm.item.idOrden);
          vm.$emit("store");
        })
        .catch((err) => {
          vm.loading.save = false;
        });
    },
  },
};
</script>

<style></style>
